import { NgModule, Component } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { NaacHeadingListComponent } from './naac-heading-list/naac-heading-list.component';
import { NaacHeadingCreateComponent } from './naac-heading-create/naac-heading-create.component';

const routes: Routes = [
  {
    path: '',
    children: [
      {
        path: 'list-page',
        component: NaacHeadingListComponent,
        data: {
          title: "List Page",
          breadcrumb: "List Page"
        }
      },
      {
        path: 'create-page',
        component: NaacHeadingCreateComponent,
        data: {
          title: "Create Page",
          breadcrumb: "Create Page"
        }
      },
      {
        path: 'naac-heading-create/:id',
        component: NaacHeadingCreateComponent,
      }
    ]
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class NaacHeadingRoutingModule { }
